import script from "./chooseIngrident.vue?vue&type=script&setup=true&lang=js"
export * from "./chooseIngrident.vue?vue&type=script&setup=true&lang=js"

import "./chooseIngrident.vue?vue&type=style&index=0&id=68bd11f9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68bd11f9"]])

export default __exports__